import type { ButtonHTMLAttributes, ReactNode } from "react";
import styles from "./Checkbox.module.css";
import { cx } from "../cx";
import { IconCheckmarkLine } from "../icons/Icon";

export type CheckboxProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "onChange" | "children"> & {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  /** 라벨. 있으면 버튼이 라벨까지 감싼다. */
  children?: ReactNode;
  size?: "medium" | "large";
};

/** SEED Checkbox. 22(대형 24) 둥근 사각형, 선택 brand. 약관 동의 행·전체 동의에 쓴다. */
export function Checkbox({ checked, onCheckedChange, children, size = "medium", className, disabled, ...rest }: CheckboxProps) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      disabled={disabled}
      className={cx(styles.root, styles[size], checked && styles.on, className)}
      onClick={() => onCheckedChange(!checked)}
      {...rest}
    >
      <span className={styles.box} aria-hidden>
        <IconCheckmarkLine size={size === "large" ? 16 : 14} />
      </span>
      {children && <span className={styles.label}>{children}</span>}
    </button>
  );
}
